import { observer } from 'mobx-react-lite';
import { View } from 'react-native';
import { useStore } from '../../../../contexts/StoreContext';
import { Illustration } from '../../../illustration/Illustration';
import { ILLUSTRATION_NAMES } from '../../../illustration/illustration.helper';
import { TestIDs } from 'src/constants/testIDs.constants';
import BaseModal from '../../base-modal/BaseModal';
import { DynamicModalProps } from '../DynamicModal.types';
import { useModalMinProductsAlertLogic } from './ModalMinProductAlert.logic';

export const ModalMinProductsAlert = observer((props: DynamicModalProps) => {
  const {
    dynamicModalVisible,
    type,
    dynamicModalLayer: { id, productLimit, groupWithLimit },
  } = props;

  const { i18n } = useStore();
  const { onCloseModal, onBackPress } = useModalMinProductsAlertLogic(props);

  return (
    <BaseModal
      testID={TestIDs.MIN_PRODUCTS_ALERT}
      modalWidth={386}
      modalIcon={
        <View style={{ width: 100, height: 100 }}>
          <Illustration name={ILLUSTRATION_NAMES.AddPhoto} />
        </View>
      }
      title={i18n.t('modal-min-products-alert:title', { limit: productLimit })}
      description={i18n.t(`modal-min-products-alert:description_${groupWithLimit}`)}
      confirmText={i18n.t('modal-min-products-alert:cta')}
      handleConfirm={onBackPress}
      onClose={onCloseModal}
      onCloseOutside={onCloseModal}
      isVisible={dynamicModalVisible}
      type={type}
      id={id}
    />
  );
});
